import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { redirectTo404 } from '@/utils';
import RapidSeries from '@elem/compPage/RapidSeries';
import { useRouter } from 'next/router';
import { GetServerSidePropsContext } from 'next/types';

const whiteLocaleList = ['us', 'ca', 'jp', 'eu', 'uk', 'de', 'fr', 'it', 'es'];
export default function Page({ SEO }: any) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidseries');
    return (
        <PageLayout isNoFixed={true}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="rapid-series-power-bank" />
            <RapidSeries />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale = 'us' }: GetServerSidePropsContext) {
    // 非白名单404
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }

    return {
        props: {},
    };
}
